import {
    get,
    put,
    putWithQuery,
    post,
    Delete,
    axios,
} from "../ApiDecorator";

/**
 * 日志记录（管理端）
 * 网关：/course/log
 */
const Log = {
    /** POST 新建日志设置 */
    createTemplate(data) {
        return post("/course/log/template/create", data);
    },
    /** PUT 编辑日志设置 */
    updateTemplate(data) {
        return put("/course/log/template/update", data);
    },
    /** GET 按项目查询模板列表 */
    getTemplateList(data) {
        return get("/course/log/template/list", data);
    },
    /** PUT 修改启用状态 */
    setTemplateStatus(data) {
        return putWithQuery("/course/log/template/status", {}, data);
    },
    /** GET 日志设置详情 */
    getTemplateDetail(data) {
        return get("/course/log/template/detail", data);
    },
    /** DELETE 删除日志设置 */
    deleteTemplate(data) {
        return Delete("/course/log/template/delete", data);
    },
    /** GET 导出日志 Excel（blob） */
    exportTemplate(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/log/template/export?${query}`, {
            responseType: "blob",
        });
    },
    /** GET 导出日志 Word（blob 为 zip，解压后为 docx，仅正式提交） */
    exportTemplateDocx(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/log/template/exportDocx?${query}`, {
            responseType: "blob",
        });
    },
    /** GET 某日提交概况与明细 */
    getDayOverview(data) {
        return get("/course/log/day/submitOverview", data);
    },

    // ===== 学员端接口 =====
    /** GET 我的日志列表（按模板分组，含每天submitted状态） */
    getUserList(data) {
        return get("/course/log/user/list", data);
    },
    /** GET 填写回显（草稿+正式提交） */
    getFillDetail(data) {
        return get("/course/log/user/fill/detail", data);
    },
    /** GET 正式提交回显（仅正式提交） */
    getFillSubmitted(data) {
        return get("/course/log/user/fill/submitted", data);
    },
    /** POST 保存草稿/正式提交（新建） */
    saveFill(data) {
        return post("/course/log/user/fill/save", data);
    },
    /** POST 编辑自己的日志（已有记录后修改） */
    editFill(data) {
        return post("/course/log/user/fill/edit", data);
    },
};

export default Log;
